import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Divider,
  Link,
} from '@mui/material';
import {
  Phone,
  LocationOn,
} from '@mui/icons-material';

const Footer: React.FC = () => {

  const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '#services' },
    { label: 'About Us', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ];

  const services = [
    'Civil Work',
    'Plumbing',
    'Carpenter',
    'False Ceiling',
    'Networking',
    'CCTV',
    'All Electrical Work',
    'Interior Design',
    'Steel Fabrication',
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        py: 6,
        mt: 8,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box 
              display="flex" 
              alignItems="center" 
              mb={2}
              flexDirection={{ xs: 'column', sm: 'row' }}
              gap={{ xs: 1.5, sm: 0 }}
              sx={{ 
                justifyContent: { xs: 'center', md: 'flex-start' },
              }}
            >
              <Box
                component="img"
                src="/logo-transparent.png"
                alt="Ishaan Construction Works"
                sx={{
                  width: 140,
                  height: 140,
                  mr: { xs: 0, sm: 2 },
                  objectFit: 'contain',
                  flexShrink: 0,
                }}
              />
              <Typography variant="h6" fontWeight="bold" textAlign={{ xs: 'center', sm: 'left' }}>
                ISHAAN CONSTRUCTION WORKS
              </Typography>
            </Box>
            <Typography 
              variant="body2" 
              color="text.secondary" 
              paragraph
              sx={{ 
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              Civil work, plumbing near me, electricians, CCTV, carpenters, false ceiling,
              home networking, interior design and steel fabrication across HSR Layout,
              Koramangala, BTM Layout, Whitefield and Bangalore — 10+ years of reliable
              workmanship.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Typography 
              variant="h6" 
              gutterBottom 
              fontWeight="bold" 
              sx={{ 
                color: 'text.primary',
                textAlign: { xs: 'center', sm: 'left' },
              }}
            >
              Quick Links
            </Typography>
            <Box 
              display="flex" 
              flexDirection="column" 
              gap={1}
              sx={{ 
                alignItems: { xs: 'center', sm: 'flex-start' },
              }}
            >
              {quickLinks.map((link, index) => (
                <Link
                  key={index}
                  href={link.href}
                  color="text.secondary"
                  underline="hover"
                  sx={{
                    color: 'text.secondary',
                    '&:hover': {
                      color: 'text.primary',
                    },
                    '&:focus': {
                      outline: 'none',
                    },
                    '&:focus-visible': {
                      outline: 'none',
                    },
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Services */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography 
              variant="h6" 
              gutterBottom 
              fontWeight="bold" 
              sx={{ 
                color: 'text.primary',
                textAlign: { xs: 'center', sm: 'left' },
              }}
            >
              Our Services
            </Typography>
            <Box 
              display="flex" 
              flexDirection="column" 
              gap={1}
              sx={{ 
                alignItems: { xs: 'center', sm: 'flex-start' },
              }}
            >
              {services.map((service, index) => (
                <Typography key={index} variant="body2" color="text.secondary">
                  {service}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid size={{ xs: 12, md: 3 }}>
            <Typography 
              variant="h6" 
              gutterBottom 
              fontWeight="bold" 
              sx={{ 
                color: 'text.primary',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              Contact Info
            </Typography>
            <Box 
              display="flex" 
              flexDirection="column" 
              gap={2}
              sx={{ 
                alignItems: { xs: 'center', md: 'flex-start' },
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Phone fontSize="small" sx={{ color: 'text.primary' }} />
                <Typography variant="body2" color="text.secondary">
                  +91 8074635096
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Phone fontSize="small" sx={{ color: 'text.primary' }} />
                <Typography variant="body2" color="text.secondary">
                  +91 9972555661
                </Typography>
              </Box>
              <Box display="flex" alignItems="flex-start" gap={1}>
                <LocationOn fontSize="small" sx={{ color: 'text.primary', mt: 0.5 }} />
                <Typography 
                  variant="body2" 
                  color="text.secondary"
                  sx={{ 
                    textAlign: { xs: 'center', md: 'left' },
                  }}
                >
                  36/A, 3rd Cross 24th Main<br />
                  Near Ranga Residency<br />
                  HSR Layout 2nd Sector, Bengaluru 102
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Copyright */}
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="center"
          alignItems="center"
          gap={2}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Ishaan Construction Works. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;

